import React from 'react'

import { Button, ModalInjectedProps, Text } from '@sketch/components'

// Images
import ImageSrc from '@sketch/icons/filing-cabinet.png'
import RetinaImageSrc from '@sketch/icons/filing-cabinet@2x.png'

import { Body, Header, Image, StyledModal } from './OnlyWorkspaceAdmins.styles'

interface OnlyWorkspaceAdminsProps extends ModalInjectedProps {
  name: string
}

export const OnlyWorkspaceAdmins: React.FCC<OnlyWorkspaceAdminsProps> = ({
  name,
  hideModal,
}) => {
  const title = 'Workspace Settings for Administrator'

  return (
    <StyledModal onCancel={hideModal}>
      <Image alt={title} src={ImageSrc} srcSet={`${RetinaImageSrc} 2x`} />
      <Header>Workspace Settings</Header>
      <Body>
        <Text>
          Only admins can manage workspace settings for &ldquo;{name}&rdquo;.
        </Text>
        <Text>Please contact a workspace admin.</Text>
        <Button variant="primary" onClick={hideModal}>
          Close
        </Button>
      </Body>
    </StyledModal>
  )
}
